import { render } from "./CompanyOverviewCard.vue?vue&type=template&id=ed5057c6&ts=true"
import script from "./CompanyOverviewCard.vue?vue&type=script&lang=ts"
export * from "./CompanyOverviewCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__